//react
import { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Mobile, PC } from "../../media/MediaQuery";

//css
import styled from "styled-components";

import next from "../../assets/img/icon/icon_more2.svg";

// responsive
import { M, T } from "../../utils/MT";

// component
export default function StateBox(props) {
    // 배송 현황 박스

    return (
        <StateWrap>
            <StateListBox>
                <StateList>
                    <State>0</State>
                    <StateName>입금대기</StateName>
                </StateList>

                <NextIcon>
                    <img src={next} alt="아이콘" />
                </NextIcon>

                <StateList>
                    <State>0</State>
                    <StateName>결제완료</StateName>
                </StateList>

                <NextIcon>
                    <img src={next} alt="아이콘" />
                </NextIcon>

                <StateList>
                    <State>0</State>
                    <StateName>상품준비중</StateName>
                </StateList>

                <NextIcon>
                    <img src={next} alt="아이콘" />
                </NextIcon>

                <StateList>
                    <State>0</State>
                    <StateName>배송시작</StateName>
                </StateList>

                <NextIcon>
                    <img src={next} alt="아이콘" />
                </NextIcon>

                <StateList>
                    <State>0</State>
                    <StateName>배송중</StateName>
                </StateList>

                <NextIcon>
                    <img src={next} alt="아이콘" />
                </NextIcon>

                <StateList>
                    <State>1</State>
                    <StateName>배송완료</StateName>
                </StateList>
            </StateListBox>
        </StateWrap>
    );
}

const StateWrap = styled.div``;
const StateListBox = styled.ul`
    display: flex;
    align-items: center;
    justify-content: center;

    width: 100%;
    height: calc(100vw * (155 / 1920));

    border-radius: 10px;
    background: #fff;
    border: 1px solid #dddddd;

    @media screen and (max-width: 1300px) {
        height: calc(100vw * (155 / 1300));
    }

    @media screen and (max-width: 900px) {
        height: ${M(100)};
        border: none;
    }
`;
const StateList = styled.li`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    width: calc(100vw * (130 / 1920));
    height: calc(100vw * (155 / 1920));

    text-align: center;

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (130 / 1300));
        height: calc(100vw * (155 / 1300));
    }

    @media screen and (max-width: 900px) {
        /* width: ${M(63)}; */
        width: calc(100% / 6);
        height: ${M(98)};
    }
`;
const State = styled.p`
    font-size: calc(100vw * (25 / 1920));

    font-family: "Noto-R";
    color: var(--main-color);

    margin-bottom: calc(100vw * (9 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (25 / 1300));

        margin-bottom: calc(100vw * (9 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(14)};

        margin-bottom: ${M(15)};
    }
`;
const StateName = styled.p`
    font-size: calc(100vw * (16 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (16 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(11)};
    }
`;
const NextIcon = styled.li`
    width: calc(100vw * (10 / 1920));

    & img {
        width: 100%;
    }

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (10 / 1300));
    }

    @media screen and (max-width: 900px) {
        display: none;
    }
`;
